export default function getQueryVariable(search, variable) {
    var vars = search.substring(1).split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/urlparser.js